import GeneralMeetingsService from 'services/GeneralMeetings.service';
import { SETTINGS } from 'common/consts/kentico';

import { observable, action, decorate } from 'mobx';

class GeneralMeetingsStore {
  latestSearches = new Map();
  otherGeneralMeetings = [];

  latestState = {
    data: [],
    page: 1,
    isExploited: false,
    category: '',
    publishYear: {
      value: ''
    }
  };

  async fetchLatestGeneralMeetings(criteria) {
    const { limit = SETTINGS.DEFAULT_LIMIT, page = 1, category } = criteria;
    const publishYear = criteria.publishYear.value;

    const cacheKey = JSON.stringify({
      category,
      publishYear,
      page,
      limit
    });

    if (this.latestState.data.length) {
      return {
        isExploited: this.latestState.isExploited,
        data: this.latestState.data,
        category: this.latestState.category,
        publishYear: this.latestState.publishYear
      };
    }

    const cachedSearch = this.latestSearches.get(cacheKey);

    if (cachedSearch) {
      return cachedSearch;
    }

    try {
      const items = await GeneralMeetingsService.fetchGeneralMeetings({
        limit,
        page,
        category,
        publishYear
      });

      if (items.isEmpty) {
        return {
          isExploited: true,
          data: []
        };
      }

      const isNextPage = !!items.pagination.nextPage;

      const data = {
        isExploited: !isNextPage,
        data: items.items
      };

      this.latestSearches.set(cacheKey, data);

      return data;
    } catch (e) {
      console.error('Failed to fetch featured GeneralMeetings data', e);
      return null;
    }
  }

  /**
   * Get GeneralMeetings news item by id
   * @param { number } id
   * @returns { GeneralMeetingsItem } Promise resolved CurrentReports news item
   */
  async getGeneralMeetingItemById(id) {
    try {
      const items = await GeneralMeetingsService.getGeneralMeetingItemById(id);
      return items.isEmpty ? null : items.items[0];
    } catch (e) {
      console.error('Failed to fetch general meeting news item data');
      return null;
    }
  }

  async getGeneralMeetingItemBySlug(slug, lang) {
    try {
      const items = await GeneralMeetingsService.getGeneralMeetingItemBySlug(
        slug,
        lang
      );
      return items.isEmpty ? null : items.items[0];
    } catch (e) {
      console.error('Failed to fetch general meeting news item data by slug');
      return null;
    }
  }
}

decorate(GeneralMeetingsStore, {
  searches: observable,
  otherCurrentReports: observable,
  fetchArticles: action
});

export default new GeneralMeetingsStore();



// WEBPACK FOOTER //
// ./src/stores/GeneralMeetings.store.js